(() => {
  if (window.wbCollectionSwatchesReady) return;
  window.wbCollectionSwatchesReady = true;

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest?.('[data-wb-card-swatch]');
    const card = swatch?.closest('product-card');
    if (!card || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopPropagation();

    const data = swatch.dataset;
    const link = card.querySelector('[ref="productCardLink"]');
    const title = card.querySelector('.wb-variant-card__title');
    const gallery = card.querySelector('.wb-variant-card__gallery');
    if (!link || !title || !gallery) return;
    const url = new URL(link.href);
    url.searchParams.set('variant', data.variantId);
    card.querySelectorAll('[ref="productCardLink"], [ref="cardGalleryLink"], [ref="productTitleLink"]')
      .forEach((anchor) => {
        anchor.href = url.href;
        if (anchor !== title) anchor.setAttribute('aria-label', `${title.textContent.trim()} — ${data.label}`);
      });
    const owner = card.closest('[data-variant-id]');
    if (owner) owner.dataset.variantId = data.variantId;
    card.dataset.featuredMediaUrl = data.image;

    const image = gallery.querySelector('.wb-variant-card__image');
    if (image && data.image) {
      image.removeAttribute('srcset');
      image.src = data.image;
      image.alt = `${title.textContent.trim()} — ${data.label}`;
    }
    let secondary = gallery.querySelector('.wb-variant-card__secondary');
    if (data.secondaryImage) {
      if (!secondary) {
        secondary = document.createElement('img');
        secondary.className = 'wb-variant-card__secondary';
        secondary.loading = 'lazy';
        secondary.width = 576;
        secondary.height = 720;
        gallery.querySelector('.wb-variant-card__image-link').append(secondary);
      }
      secondary.removeAttribute('srcset');
      secondary.src = data.secondaryImage;
      secondary.alt = image?.alt || data.label;
    } else {
      secondary?.remove();
    }

    card.querySelector('.wb-variant-card__label').textContent = data.label;
    const price = card.querySelector('.wb-variant-card__price');
    price.textContent = data.price;
    if (data.comparePrice) {
      const compare = document.createElement('s');
      compare.textContent = data.comparePrice;
      price.append(' ', compare);
    }
    gallery.querySelector('.wb-variant-card__badge')?.remove();
    if (data.badge) {
      const badge = document.createElement('span');
      badge.className = 'wb-variant-card__badge';
      badge.textContent = data.badge;
      gallery.append(badge);
    }
    card.querySelectorAll('[data-wb-card-swatch]').forEach((item) => {
      const selected = item === swatch;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', String(selected));
    });
    let status = card.querySelector('[data-wb-swatch-status]');
    if (!status) {
      status = document.createElement('span');
      status.className = 'visually-hidden';
      status.dataset.wbSwatchStatus = '';
      status.setAttribute('role', 'status');
      card.append(status);
    }
    status.textContent = `${data.label}, ${data.price}`;
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === ' ' && event.target.matches('[data-wb-card-swatch]')) {
      event.preventDefault();
      event.target.click();
    }
  });
})();
